<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<QueryCondition @query="query" ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="userTag">
					<Input v-model="row.userTag" clearable @on-blur="changeRamrk(row)" />
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">禁用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
				</template>

			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/UserQueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				deneyShow: false,
				denyCheckData: {

				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					}, {
						title: 'APP',
						width: 200,
						align: 'center',
						render: (h, params) => {
							let name;
							let val = params.row.channel;
							if (val == '1') {
								name = '兼职直聘'
							} else if (val == '2') {
								name = '校园直聘'
							} else if (val == '3') {
								name = '线上日结宅家赚'
							} else if (val == '4') {
								name = '蜗牛兼职'
							}else if (val == '5') {
								name = '支付宝小金豆'
							}else if (val == '6') {
								name = '大熊兼职商家版'
							}else if (val == '7') {
								name = '大熊兼职'
							}else if (val == '8') {
								name = '米罐兼职'
							}
							return h('span', name)
						}
					}, {
						title: '用户ID',
						width: 200,
						key: 'id',
						align: 'center'
					},
					{
						title: '用户姓名',
						width: 200,
						key: 'userName',
						align: 'center'
					},
					{
						title: '性别',
						width: 200,
						key: 'sex',
						align: 'center'
					},
					{
						title: '出生年月',
						key: 'birthday',
						align: 'center',
						width: 200,
					},
					{
						title: '教育经历',
						key: 'education',
						align: 'center',
						width: 200,
					}
					/* , {
											title: '渠道来源',
											align: 'center',
											width: 150,
										} */
					,
					{
						title: '用户手机号',
						key: 'mobile',
						align: 'center',
						width: 250,
					},
					{
						title: '首次登陆时间',
						key: 'createTime',
						align: 'center',
						width: 250,
					},
					{
						title: '报名数',
						key: 'applyNum',
						align: 'center',
						width: 200,
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '1') {
								name = '启用'
							} else {
								name = '禁用'
							}
							return h('span', name)
						}
					}, {
						title: '备注',
						key: 'remark',
						align: 'center',
						width: 200,
					}, {
						title: '标签',
						slot: 'userTag',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						align: 'center',
						width: 200,
					}
				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.userInfoPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			changeRamrk(row) {
				const that = this
				api.statistics
					.updateUserTag({
						'id': row.id,
						userTag: row.userTag
					})
					.then(res => {
						that.$Message.success('Success!');

					})
			},
			updateStatus(id, status) {
				const that = this
				api.statistics
					.updateUserStatus({
						'userId': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},

		},


	}
</script>
